import { round } from '../../../../../util/numbers/rounder';

export function simpleFormatter(params, withPercent = true) {
  return `${round(params.data.value, 1)}${withPercent ? '%' : ''}`;
}

export function displayAndFormatOnlyFirst(params, withPercent = true) {
  if (params.seriesIndex === 0) {
    return simpleFormatter(params, withPercent);
  }

  return '';
}

export function getLabelFormatterThatDisplaysOnly(index, withPercent = true) {
  return (params) => {
    if (params.dataIndex === index) {
      return simpleFormatter(params, withPercent);
    }

    return '';
  };
}

export function getLabelFormatterThatDisplaysWhenLegendEnable(legendDataProps, withPercent = true) {
  return (params) => {

    const props = legendDataProps[params.dataIndex];

    if (props.enabled) {
      return simpleFormatter(params, withPercent);
    }

    return '';
  };
}
